<template>
    <div class="seg-tabs">
        <button v-for="op in options" :key="op.value" type="button" class="seg-tab"
            :class="{ active: op.value === value }" @click="$emit('change', op.value)">
            {{ op.name }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'SegmentedTabs',
    props: {
        options: {
            type: Array,
            default: () => [],
        },
        value: {
            type: [String, Number],
            default: null,
        }
    }
}
</script>

<style scoped>
.seg-tabs {
    display: flex;
    gap: 2px;
    padding: 3px;
    border-radius: 8px;
    background: var(--v-surface2-base);
}

.seg-tab {
    flex: 1;
    min-width: 0;
    padding: 5px 6px;
    border-radius: 6px;
    background: transparent;
    color: var(--v-txtMuted-base);
    font-size: 11px;
    font-weight: 700;
    text-transform: none;
    letter-spacing: normal;
    cursor: pointer;
    transition: color .15s, background .15s;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.seg-tab.active {
    background: var(--v-surface-base);
    color: var(--v-txtPrimary-base);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
}
</style>
